import React, { useEffect, useState } from 'react';
import { Button, Card, Col, Divider, List, Popover, Row, Tag } from 'antd';
import { CheckCircleOutlined, CheckOutlined } from '@ant-design/icons';
import Package from '../../classes/package';
import { Utils } from '../../tools/utils';
import { useTranslation } from 'react-i18next';
import { useStore } from 'store';
import SicuriProtettiServices from 'js/data/sicuri-protetti-services';

const utils = new Utils();

interface IProps {
    data: Package;
    productFun: (productId: number, product?: string, price?: string, professional?: boolean) => void;
    periodFun: (periodId: number, period: string, productId: number) => void;
    optionsFun: (option: string, op: number) => void;
}

const PackageForm = (props: IProps) => {
    const { t } = useTranslation();
    const [packages, setPackages] = useState<Package[]>([]);
    const setLoading = useStore((state) => state.setLoading);

    useEffect(() => {
        const getSicuriEProtettiPackages = async () => {
            setLoading(true);
            const packages = await SicuriProtettiServices.getSicuriEProtettiPackages(1);
            setPackages(packages);
            if (props.data.productId !== -1) {
                document.getElementById('check-' + props.data.productId)!.hidden = false;
                document.getElementById('card-' + props.data.productId)!.style.backgroundColor = '#e6f7ff';
                document.getElementById('periods-div-' + props.data.productId)!.hidden = false;
                if (document.getElementById('options-div-' + props.data.productId) != null)
                    document.getElementById('options-div-' + props.data.productId)!.hidden = false;
                if (props.data.periodId !== -1) {
                    const period = document.getElementById('tag-period-' + props.data.productId + '-' + props.data.periodId);
                    period!.classList.add('tag-selected');
                    period!.classList.replace('ant-tag-default', 'ant-tag-green');
                    const circle = period!.querySelector('.anticon-check-circle');
                    circle!.removeAttribute('hidden');
                }
                let i = 0;
                for (i; i < props.data.options.length; i++) {
                    utils.SetOptionSelected(
                        'button-option-' + props.data.productId + '-' + props.data.options[i],
                        'check-' + props.data.productId + '-' + props.data.options[i]
                    );
                }
            }
            setLoading(false);
        };

        getSicuriEProtettiPackages();
        // eslint-disable-next-line
    }, []);

    return (
        <div className="center">
            <h2 className="font-weight-600 title-content">{t('sicuri&protetti.titles.title0')}</h2>
            <br />
            <List
                grid={{
                    gutter: 16,
                    xs: 1,
                    sm: 2,
                    md: 3,
                    lg: 4,
                    xl: 4,
                    xxl: 4,
                }}
                dataSource={packages}
                renderItem={(item: Package) => (
                    <List.Item>
                        <Card
                            id={'card-' + item.productId}
                            className="background-grey"
                            hoverable
                            onClick={() => props.productFun(item.productId, item.product, item.price, item.professional)}
                            title={
                                <Row>
                                    <Col span={18}>
                                        <h3>{t('sicuri&protetti.packages.' + item.productId + '.name')}</h3>
                                    </Col>
                                    <Col span={6} className="right">
                                        <CheckOutlined
                                            id={'check-' + item.productId}
                                            style={{ fontSize: '22px', color: '#008000' }}
                                            hidden
                                        />
                                    </Col>
                                </Row>
                            }
                        >
                            <p
                                style={{
                                    fontSize: 14,
                                    textAlign: 'left',
                                    textJustify: 'inter-word',
                                }}
                            >
                                {t('sicuri&protetti.packages.' + item.productId + '.description')}
                            </p>
                            <div id={'options-div-' + item.productId} hidden>
                                {item.options.length !== 0 && (
                                    <div>
                                        <Divider className="small-divider" />
                                        <div className="center">
                                            <p style={{ marginBottom: 0 }}>{t('commonClass.options')} : </p>
                                            <div style={{ marginTop: '5px' }}>
                                                {item.options.map((option) => (
                                                    <Popover
                                                        content={
                                                            <div>
                                                                <p style={{ maxWidth: 300 }}>
                                                                    {t('sicuri&protetti.options.' + option + '.description')}
                                                                </p>
                                                                <div className="center">
                                                                    <p>
                                                                        {t('commonClass.price')} :{' '}
                                                                        <strong>
                                                                            € {t('sicuri&protetti.options.' + option + '.price')}
                                                                        </strong>
                                                                    </p>
                                                                </div>
                                                                {/* <div className={'center'}>
                                                                    {props.data.options.includes(option) &&
                                                                    props.data.productId === item.productId ? (
                                                                        <Button
                                                                            type={'link'}
                                                                            id={'remove-' + item.productId + '-' + option}
                                                                            onClick={() => props.optionsFun(option, 1)}
                                                                        >
                                                                            {t('commonClass.remove')}
                                                                        </Button>
                                                                    ) : (
                                                                        <Button
                                                                            type={'link'}
                                                                            id={'add-' + item.productId + '-' + option}
                                                                            onClick={() => props.optionsFun(option, 0)}
                                                                        >
                                                                            {' '}
                                                                            {t('commonClass.add')}
                                                                        </Button>
                                                                    )}
                                                                </div> */}
                                                            </div>
                                                        }
                                                        key={item.productId + '-' + option}
                                                        title={
                                                            <h2 className={'center'}>{t('sicuri&protetti.options.' + option + '.name')}</h2>
                                                        }
                                                        trigger="focus"
                                                    >
                                                        <Button style={{ margin: 2 }} id={'button-option-' + item.productId + '-' + option}>
                                                            <CheckOutlined
                                                                id={'check-' + item.productId + '-' + option}
                                                                style={{ fontSize: '10px', color: '#008000' }}
                                                                hidden
                                                            ></CheckOutlined>
                                                            {t('sicuri&protetti.options.' + option + '.name')}
                                                        </Button>
                                                    </Popover>
                                                ))}
                                            </div>
                                        </div>
                                    </div>
                                )}
                            </div>
                            <Divider className="small-divider"></Divider>
                            <div className="center">
                                <p>
                                    {t('commonClass.price')} :{' '}
                                    <strong>€ {t('sicuri&protetti.packages.' + item.productId + '.price')}</strong>
                                </p>
                                <div style={{ marginTop: '5px' }} id={'periods-div-' + item.productId} hidden>
                                    {item.periods.map((period) => (
                                        <Tag
                                            id={'tag-period-' + item.productId + '-' + period.value}
                                            onClick={() => props.periodFun(period.value, period.label, item.productId)}
                                            icon={<CheckCircleOutlined hidden />}
                                            key={period.value}
                                            color={'default'}
                                        >
                                            {t(period.label)}
                                        </Tag>
                                    ))}
                                </div>
                            </div>
                        </Card>
                    </List.Item>
                )}
            />
        </div>
    );
};

export default PackageForm;
